import React, { FC, ReactNode, useContext } from "react";
import { Navigate } from "react-router-dom";

import { UPSAPIContext, UPSContext } from "@app/provider";
import { routes } from "@app/routing";

interface RequireUpsSessionProps {
  children: ReactNode;
}

export const RequireUpsSession: FC<RequireUpsSessionProps> = ({ children }) => {
  const { upsAccessToken, upsPatientUid } = useContext(UPSContext);
  const {
    upsApiProviderState: { guestValidationData },
  } = useContext(UPSAPIContext);

  if (
    !upsAccessToken ||
    !upsPatientUid ||
    !guestValidationData?.paymentRequestId
  ) {
    return <Navigate to={routes.upsReviewInvoice} replace />;
  }

  return <>{children}</>;
};

export default RequireUpsSession;
